var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34427",
    "data-name": "Group 34427",
    transform: "translate(13716 18937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10185",
    "data-name": "Rectangle 10185",
    width: 18,
    height: 18,
    transform: "translate(-13716 -18937)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33553",
    "data-name": "Group 33553",
    transform: "translate(21 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71803",
    "data-name": "Path 71803",
    d: "M82,60h1.235v3.088H82Z",
    transform: "translate(-13812.883 -18990.941)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71804",
    "data-name": "Path 71804",
    d: "M72.706,55.971H65.294V51.235h7.412ZM69,61.324a2.059,2.059,0,1,1,2.059-2.059A2.065,2.065,0,0,1,69,61.324ZM75.176,50H64.059L62,52.059V63.176a.826.826,0,0,0,.824.824H75.176A.826.826,0,0,0,76,63.176V50.824A.826.826,0,0,0,75.176,50Z",
    transform: "translate(-13797 -18983)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71805",
    "data-name": "Path 71805",
    d: "M93,92h1.235v1.235H93Z",
    transform: "translate(-13821.617 -19016.354)",
    fill: "#5076ba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.e388fb693ac6bfdd60cf59bbd389db62.svg";
export { ForwardRef as ReactComponent };